import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authState } from '../components/login/auth';

const PrivateRoute = (props) =>
  (authState.isAuthenticated ? <Route {...props} /> : <Redirect to="/home" />);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/util/private-routes.jsx